import { t } from 'src/i18n';

// `text`-feltene er lazy gettere slik at i18n-`t()` kjøres ved oppslag (kalltid),
// ikke ved import. `value` er enum-koder som sammenliknes i koden — uoversatt.
export const reminderOptions = [
  {
    value: 'AT_START',
    get text() {
      return t('reminders.atStart');
    },
  },
  {
    value: 'ONE_HOUR_BEFORE',
    get text() {
      return t('reminders.oneHourBefore');
    },
  },
  {
    value: 'TWO_HOURS_BEFORE',
    get text() {
      return t('reminders.twoHoursBefore');
    },
  },
  {
    value: 'THREE_HOURS_BEFORE',
    get text() {
      return t('reminders.threeHoursBefore');
    },
  },
  {
    value: 'FIVE_HOURS_BEFORE',
    get text() {
      return t('reminders.fiveHoursBefore');
    },
  },
  {
    value: 'ONE_DAY_BEFORE',
    get text() {
      return t('reminders.oneDayBefore');
    },
  },
  {
    value: 'TWO_DAYS_BEFORE',
    get text() {
      return t('reminders.twoDaysBefore');
    },
  },
  {
    value: 'ONE_WEEK_BEFORE',
    get text() {
      return t('reminders.oneWeekBefore');
    },
  },
];
